/**
 * Bolivian boliviano.
 */
export var BOB = {
  code: 'BOB',
  base: 10,
  exponent: 2
};